import styles from '../../styles/BoxAvailabilty.module.css';
import { useAppContext } from '../../context/shared';
import { LOCALES } from '../../lib/constants';
import { BoxAvailability } from '../../lib/types/cms/fields/cms-box-availabilty';

interface BoxAvailabiltyProps {
  availability: BoxAvailability;
}

const getText = (availability: BoxAvailability, locale: string) => {
  switch (availability) {
    case BoxAvailability.inStock:
      return locale === LOCALES.de
        ? 'Sofort verfügbar (1-3 Tage Lieferzeit)'
        : 'Available immediately (Delivered in 2 to 3 days)';

    case BoxAvailability.lowStock:
      return locale === LOCALES.de
        ? 'Geringer Bestand (2-3 Tage Lieferzeit)'
        : 'Low in stock (Delivered in 2 to 3 days)';

    case BoxAvailability.outOfStock:
      return locale === LOCALES.de ? 'Ausverkauft' : 'Out of stock';
    default:
      return '';
  }
};

export default function BoxAvailabilty({ availability }: BoxAvailabiltyProps) {
  const { locale } = useAppContext();

  const styleByAvailability: Record<BoxAvailability, unknown> = {
    inStock: styles['in-stock'],
    lowStock: styles['low-stock'],
    outOfStock: styles['out-of-stock'],
  };
  return (
    <div className={styles.boxAvailability}>
      <span
        className={[
          styles.availabilityDot,
          styleByAvailability[availability],
        ].join(' ')}
      ></span>
      <p className={styles.availabilityText}>{getText(availability, locale)}</p>
    </div>
  );
}
